import React from 'react';
import { AlertTriangleIcon, CheckIcon, LockIcon } from 'lucide-react';
import { safeguards } from '../../data/samplePrompts';
export function AiSafeguards() {
  return <div className="mx-auto mt-8 max-w-3xl space-y-6" data-id="element-158" data-mp="1vq7tadhpncxb">
      <div className="flex items-start gap-3 rounded-2xl border border-blush/30 bg-blush-soft p-5" data-id="element-159" data-mp="1vowny98m9x43">
        <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-blush-deep" aria-hidden="true" data-id="element-160" data-mp="1qro6ybz7fz4f" />
        <p className="text-sm leading-relaxed text-plum/80" data-id="element-161" data-mp="13227roiu1jwf">
          <span className="font-bold text-plum" data-id="element-162" data-mp="y2zd8y0haw2p">L’IA assiste la rédaction.</span> Elle ne remplace jamais votre jugement
          professionnel, votre vérification des faits ou les procédures applicables à votre service.
        </p>
      </div>

      <div className="rounded-2xl bg-plum p-6 text-white sm:p-8" data-id="element-163" data-mp="17zc6jus437wx">
        <h3 className="flex items-center gap-2 font-display text-lg font-black sm:text-xl" data-id="element-164" data-mp="ka9ia42z2gtg">
          <LockIcon className="h-5 w-5 shrink-0 text-grape-soft" aria-hidden="true" data-id="element-165" data-mp="fcrgqyrab3vh" />
          Une méthode conçue pour éviter les erreurs classiques de l’IA
        </h3>
        <p className="mt-3 text-sm text-white/70" data-id="element-166" data-mp="9q2p620lv2mi">SIGMA SMART™ repose sur un principe essentiel :</p>
        <p className="mt-2 font-display text-xl font-black leading-snug text-white sm:text-2xl" data-id="element-167" data-mp="egss78lk6te1">
          Ne laissez jamais l’IA inventer ce que vous ne lui avez pas fourni.
        </p>
        <p className="mt-4 text-sm text-white/70" data-id="element-168" data-mp="jhqb5nee7rgl">
          Les prompts utilisent des champs personnalisables et des consignes permettant notamment de :
        </p>
        <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-169" data-mp="3mx4fhe06i1h9">
          {safeguards.map(s => <li key={s} className="flex items-start gap-2 text-sm text-white/90" data-id="element-170" data-mp="3ruxla5xkkth0">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape-soft" strokeWidth={3} data-id="element-171" data-mp="pnyso8saxc5" />
              {s}
            </li>)}
        </ul>
      </div>
    </div>;
}